<script setup>

</script>

<template>
    <Panel>
        <template #header>
            <h4>Site</h4>
        </template>
    </Panel>
</template>

<style scoped>

</style>